module.exports = __webpack_public_path__ + "media/images/manager-login-282b37082bdd7490c49f890b2f1b24e3.jpg";